import React from 'react';
import assetify from '@quintype/framework/assetify';
import { ShareIcon } from '../../../../assets/icons/social/share.js';
import { CloseIcon } from '../../../../assets/icons/social/close.js';
import { FbShare } from '../../../../assets/icons/social/fb-share.js';
import { TwitterShare } from '../../../../assets/icons/social/twitter-share.js';
import { LinkedinShare } from '../../../../assets/icons/social/linkedin-share.js';
import { GplusShare } from '../../../../assets/icons/social/gplus-share.js';
import { WhatsappShare } from '../../../../assets/icons/social/whatsapp-share.js';
import { breakpoint } from '../../../../utils/breakpoint';

function getSocialShareData({ fbUrl, twitterUrl, gplusUrl, linkedinUrl, whatsappUrl, height = "24", width = "24", color }) {
  return [
    { url: fbUrl, icon: <FbShare width={width} height={height} color={color ? color : "#4e71a8"} />, alt: "fb icon", testAttr: "data-fb"},
    { url: twitterUrl, icon: <TwitterShare width={width} height={height} color={color ? color : "#1db7eb"} />, alt: "twitter icon", testAttr: "data-tw"},
    { url: gplusUrl, icon: <GplusShare width={width} height={height} color={color ? color : "#dd4b39"} />, alt: "gplus icon", testAttr: "data-gp"},
    { url: linkedinUrl, icon: <LinkedinShare width={width} height={height} color={color ? color : "#0077B5"} />, alt: "linkedin icon", testAttr: "data-ln"},
    { url: whatsappUrl, icon: <WhatsappShare width={width} height={height} color={color ? color : "#25d366"} />, alt: "whatsapp share", testAttr: "data-wp"}
  ];
}

export function popupSocialShareData({ fbUrl, twitterUrl, gplusUrl, linkedinUrl, whatsappUrl, height = "18", width = "18", color = "#fff" }) {
  return [
    { url: fbUrl, icon: <FbShare width={width} height={height} color={color} />, bgColor: "#4e71a8", text: "Facebook", alt: "fb icon"},
    { url: twitterUrl, icon: <TwitterShare width={width} height={height} color={color} />, bgColor: "#1db7eb", text: "Twitter", alt: "twitter icon"},
    { url: gplusUrl, icon: <GplusShare width={width} height={height} color={color} />, bgColor: "#dd4b39", text: "Google Plus", alt: "gplus icon"},
    { url: linkedinUrl, icon: <LinkedinShare width={width} height={height} color={color} />, bgColor: "#0077B5", text: "LinkedIn", alt: "linkedin icon"},
    { url: whatsappUrl, icon: <WhatsappShare width={width} height={height} color={color} />, bgColor: "#25d366", text: "Whatsapp", alt: "whatsapp share"}
  ];
}

function getSocialShareElem(url, icon, alt, testAttrKey, index) {
  const testAttr = { [testAttrKey]: "true" };

  return <li className="social-share-icon" {...testAttr} key={`social-item-${index}`}>
    <a href={url} target="_blank">
      { icon }
    </a>
  </li>;
}

export function getActionIcon(open, grey, greyShade, primaryColor) {
  const color = grey ? greyShade : primaryColor;

  return open ?
    <CloseIcon width="24" height="24" color={color} /> :
    <ShareIcon width="24" height="24" color={color} />;
}

export function getIconsList(params, vertical) {
  const iconsList = getSocialShareData(params);
  const tabletList = vertical ? null : iconsList.slice(0,2).map(({ url, icon, alt, testAttr }, index) => getSocialShareElem(url, icon, alt, testAttr, index));
  const desktopList = iconsList.map(({ url, icon, alt, testAttr }, index) => getSocialShareElem(url, icon, alt, testAttr, index));

  return breakpoint('tablet') ? tabletList : desktopList;
}